


















































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { filterEmpty } from '@acgn/herm/src/util/business';
import { namespace } from 'vuex-class';
import { AcgnFormTitle, AcgnStaffCake } from '@/components/';
import { AcgnPop, AcgnUpload } from '@acgn/herm/src/ui';
import { getComicUploadImageSts } from '@/api/ossClient';
const ComicAction = namespace('desk/comic').Action;
import event from '@acgn/herm/src/util/event';
const TaskGroupAction = namespace('desk/taskGroup').Action;
const TaskGroupGetter = namespace('desk/taskGroup').Getter;
const pinyin = require('pinyin');
const AuthGetter = namespace('desk/auth').Getter;
@Component({
  components: {
    AcgnPop,
    AcgnUpload,
    AcgnFormTitle,
    AcgnStaffCake
  }
})

/**
 * 上传稿件
 */
export default class AcgnUploadFile extends Vue {
  @Prop() public visible: any; // 是否显示弹框
  @Prop() public uploadMoleSta: any; // 点击显示弹框
  @Prop() public comicMessage: any; // 漫画信息
  @Prop() public refreshExamine: any; // 刷新列表
  @TaskGroupAction private submitFile: any; // 获取漫画项目列表
  @TaskGroupGetter private loadings: any; // 章节loading
  @AuthGetter private userInfo: any;
  private linkMessage: any = {};
  private proNameCh: any = '';
  private imageList: any = [];
  private fileList: any = [];

  private uploadPics: any = { // 图片上传
    image: []
  };
  private uploadFiles: any = { // 附件上传
    image: []
  };

  private uploadLoading: any = { // 图片上传状态
    shareImg: false
  };
  private imgOpts: any = { // 图片上传配置
    shareImg: null
  };
  private fileOpts: any = { // 附件上传配置
    shareImg: null
  };

  private postData: any = {
    submit_user_id: undefined,
    nas_url: undefined
  };

  @Watch('visible')
  private wacthVisible() {
    this.postData.submit_user_id = undefined;
    this.postData.nas_url = undefined;
    this.uploadPics.image = [];
    this.uploadFiles.image = [];
  }

  // 提交
  private async submit() {
    const {groupId, groupName, id, projectId, taskName} = this.comicMessage;
    const params = {
      project_id: projectId,
      project_name: this.proNameCh,
      task_group_id: groupId,
      task_group_name: groupName,
      task_id: id,
      task_name: taskName,
      link_id: this.linkMessage.id,
      link_name: this.linkMessage.name,
      preview_images: this.imageList,
      attach_images: this.fileList,
      ...this.postData
    };
    try {
      if (this.uploadPics.image.length <= 0) {
        this.$message.error('请上传预览图');
        return false;
      }
      // if (this.uploadFiles.image.length <= 0) {
      //   this.$message.error('请上传附件');
      //   return false;
      // }

      // 检测nas_url地址是否正确
      if (this.postData.nas_url && !/https?:\/\//.test(this.postData.nas_url)) {
        this.$message.error('请填写正确的NAS地址');
        return false;
      }
      if (!params.submit_user_id) {
        this.$message.error('请选择画手');
        return false;
      }
      const {raw} = await this.submitFile(params);
      setTimeout(() => {
        this.refreshExamine();
      }, 2000);
      this.$message.success('提交成功');
      this.$emit('update:visible', false);
    } catch (ex) {
      this.$message.error(ex.message);
    }
  }

  get show() {
    return this.visible;
  }
  set show(v) {
    this.$emit('update:visible', v);
  }

  // 上传图片回调
  private getImageAddress(data: any) {
    this.imageList = [];
    const sortData = data.sort((a: any, b: any) => {
      return a.rawName.localeCompare(b.rawName);
    });
    sortData.map((i: any) => {
      this.imageList.push(i.name);
    });
  }

  // 上传附件回调
  private getFileAddress(data: any) {
    this.fileList = [];
    data.map((i: any) => {
      this.fileList.push(i.name);
    });
  }
  // 关闭弹框
  private close() {
    event.emit('$closeBreakPoint');
  }

  private created() {
    event.on('$uploadFile', async (data: any) => {
      this.linkMessage = data;
      this.uploadMoleSta(true);
      const group = pinyin(this.comicMessage.groupName, {style: pinyin.STYLE_NORMAL}).join('').replace(/[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/g, '');
      const task = pinyin(this.comicMessage.taskName, {style: pinyin.STYLE_NORMAL}).join('').replace(/[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/g, '');
      const link = pinyin(data.name, {style: pinyin.STYLE_NORMAL}).join('').replace(/[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/g, '');
      const proName = pinyin(this.proNameCh, {style: pinyin.STYLE_NORMAL}).join('').replace(/[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/g, '');
      const {groupId, groupName, id, projectId, taskName} = this.comicMessage;
      const address = `${projectId + proName}/${groupId + group}/${id + task}/${this.linkMessage.id + link}`;
      this.imgOpts.shareImg = {
        action: getComicUploadImageSts,
        autoName: true,
        prefix: `${address}/`,
        key: 'filename',
        handle: true
      };
      this.fileOpts.shareImg = {
        action: getComicUploadImageSts,
        autoName: true,
        prefix: `${address}/`,
        handle: true,
        keepSufix: true
      };
    });

    event.on('$projectName', async (data: any) => {
      this.proNameCh = data;
    });
  }
}
